const benefits = [
  {
    icon: 'ri-award-line',
    title: 'Curated Excellence',
    description:
      'Your villa appears alongside a select handful of elite properties, never lost in a sea of listings. We are building a brand synonymous with quality, and every property we feature reflects that standard.',
    highlight: 'Selective listing criteria',
  },
  {
    icon: 'ri-global-line',
    title: 'Affluent Audience',
    description:
      'We target high-net-worth padel enthusiasts who travel specifically to play, and spend accordingly. Our marketing reaches premium sports-lifestyle communities across Europe and beyond.',
    highlight: 'High-intent luxury guests',
  },
  {
    icon: 'ri-medal-line',
    title: 'Founding Partner Status',
    description:
      'Early partners receive priority placement, premium profile features, and zero platform commission during our launch period. List now, pay nothing. Your early trust earns lasting advantages within our platform.',
    highlight: 'Zero commission at launch',
  },
  {
    icon: 'ri-team-line',
    title: 'Coach Booking Network',
    description:
      'Guests at your villa can book local padel coaches directly through the platform, creating an additional revenue stream and elevating the guest experience beyond the court.',
    highlight: 'Exclusive value-add service',
  },
  {
    icon: 'ri-camera-3-line',
    title: 'Premium Presentation',
    description:
      'We work with you to showcase your property at its finest, with dedicated villa profiles, professional copy, and high-quality visual treatment that goes far beyond a standard listing page.',
    highlight: 'Bespoke property profiles',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'No Booking, No Fee',
    description:
      'You only ever pay when a guest books your villa. No listing fees, no monthly charges, no hidden costs. PadelVillas is simply another high-quality channel putting your property in front of guests who are actively searching for it.',
    highlight: 'Performance-only model',
  },
];

export default function WhyListWithUs() {
  return (
    <section id="why-list" className="py-28 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="font-inter text-xs text-[#D4845C] uppercase tracking-[0.2em] font-medium mb-5">
            Why List With Us
          </p>
          <h2 className="font-cormorant text-5xl lg:text-6xl font-light text-[#2C2C2C] leading-[1.1] mb-6">
            Built for Villa Owners Who<br />
            <em className="italic">Demand More.</em>
          </h2>
          <p className="font-inter font-light text-[#6B6B6B] text-base max-w-xl mx-auto leading-relaxed">
            We are not another generic booking platform. PadelVillas is a purpose-built destination crafted to elevate your property and attract guests who truly appreciate it.
          </p>
        </div>

        {/* Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((b) => (
            <div
              key={b.title}
              className="bg-white rounded-2xl p-8 hover:shadow-md transition-shadow duration-300 group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#FAF8F5] group-hover:bg-[#D4845C]/10 transition-colors duration-300 mb-6">
                <i className={`${b.icon} text-xl text-[#D4845C]`} />
              </div>
              <div className="inline-block bg-[#D4845C]/10 text-[#D4845C] text-xs font-inter font-medium tracking-wide px-3 py-1 rounded-full mb-4">
                {b.highlight}
              </div>
              <h3 className="font-cormorant text-2xl font-semibold text-[#2C2C2C] mb-3">{b.title}</h3>
              <p className="font-inter font-light text-[#6B6B6B] text-sm leading-relaxed">{b.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
